export const SECTIONS = {
    PROFILE: 'profile',
    LANGUAGE: 'language',
    EVENTS: 'events'
};